export default __webpack_public_path__ + "static/media/imgDarkQUALGO.05c7958c.png";